//when the document is ready, find all elements with the class 'tooltip' and initialize a new Tooltip for each one
document.addEventListener('DOMContentLoaded', function() {
    //on click of .tooltip span.icon, toggle the 'active' class on the parent .tooltip element
    console.log('[tt] Document ready, initializing tooltips');
    document.querySelectorAll('.tooltip a.tt-icon').forEach(function(icon) {
        icon.addEventListener('click', function() {
            console.log('[tt] Tooltip icon clicked');
            this.parentElement.classList.toggle('active');
        });
    });

    //on click of .tooltip .close-button, remove the 'active' class from the parent .tooltip element
    document.querySelectorAll('.tooltip .close-button').forEach(function(button) {
        button.addEventListener('click', function() {
            console.log('[tt] Tooltip close button clicked');
            this.closest('.tooltip').classList.remove('active');
        });
    });

    // Optional: Close tooltip when clicking outside of it
    document.addEventListener('click', function(event) {
        if (!event.target.closest('.tooltip .content') && !event.target.closest('.tooltip a.tt-icon')) {
                document.querySelectorAll('.tooltip.active').forEach(function(tooltip) {
                tooltip.classList.remove('active');
            });
        } 
    });
});